import { createCRUDHook } from './createCRUDHook';
import { BlackoutDaysDto } from 'utils/models';
import { BLACKOUT_DAY } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<BlackoutDaysDto>({
  entityName: 'BlackoutDays',
  endpoint: BLACKOUT_DAY,
});

export const BlackoutDaysContext = Context;
export const useBlackoutDaysManager = useManager;
export const useBlackoutDays = useConsumer;
